import { usePortalAuthStore } from "../../stores/auth/portal-auth.store";
import { logoutPortalUser } from "../../services/auth/portal-auth.service";
import { logger } from "../../utils";
import { useCallback, useState } from "react";
/**
 * useAuth — hook global untuk session management
 * Tersedia di semua MF via @pena/shared (tanpa react-query)
 *
 * @param onAfterLogout - callback opsional setelah logout (contoh: queryClient.clear())
 */
export const usePortalAuth = (onAfterLogout) => {
    const clearAuth = usePortalAuthStore((state) => state.clearSession);
    const [logoutLoading, setLogoutLoading] = useState(false);
    const logout = useCallback(async () => {
        setLogoutLoading(true);
        try {
            await logoutPortalUser();
        }
        catch (err) {
            // API logout gagal (network error, token expired, dll).
            // Refresh token mungkin masih valid di server — server side cleanup tidak terjamin.
            // Local session TETAP dibersihkan di finally untuk memastikan client-side aman.
            logger.warn("[AUTH] Logout API gagal — sesi lokal tetap dibersihkan.", {
                error: err?.message ?? String(err),
            });
        }
        finally {
            // Portal doesn't use menus from Backoffice, so just clear auth
            clearAuth();
            onAfterLogout?.();
            setLogoutLoading(false);
        }
    }, [clearAuth, onAfterLogout]);
    const user = usePortalAuthStore((s) => s.user);
    const lembaga = usePortalAuthStore((s) => s.lembaga);
    const currentCabang = usePortalAuthStore((s) => s.currentCabang);
    const availableCabang = usePortalAuthStore((s) => s.availableCabang);
    const accessToken = usePortalAuthStore((s) => s.accessToken);
    const accessExpiredAt = usePortalAuthStore((s) => s.accessExpiredAt);
    const terkaitList = usePortalAuthStore((s) => s.terkaitList);
    return {
        logout,
        logoutLoading,
        user,
        lembaga,
        currentCabang,
        availableCabang,
        terkaitList,
        accessToken,
        accessExpiredAt,
    };
};
